/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostTrendByDimensionGroupWidgetConfiguration extends models.BaseGroupByDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostTrendByDimensionGroupWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostTrendByDimensionGroupWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostTrendByDimensionGroupWidgetConfiguration>): CostTrendByDimensionGroupWidgetConfiguration {
        let obj = Object.assign(new CostTrendByDimensionGroupWidgetConfiguration(), model);
        CostTrendByDimensionGroupWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostTrendByDimensionGroupWidgetConfiguration>): CostTrendByDimensionGroupWidgetConfiguration {
        if (!model) return null;
        return CostTrendByDimensionGroupWidgetConfiguration.newInstance(<CostTrendByDimensionGroupWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostTrendByDimensionGroupWidgetConfiguration) {
        if (!obj) return;

        models.CostTrendByDimensionGroupWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostTrendByDimensionGroupWidgetConfiguration): boolean {
        if (models.BaseGroupByDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostTrendByDimensionGroupWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
